import React, { useState, useRef, useEffect } from 'react';
import './LiveStream.css';

function LiveStream() {
  const streamUrl = 'https://ns3.vermantiagaming.com/live/attheraces/playlist.m3u8';
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = streamUrl;
    } else if (window.Hls && window.Hls.isSupported()) {
      const hls = new window.Hls();
      hls.loadSource(streamUrl);
      hls.attachMedia(video);
      
      return () => {
        hls.destroy();
      };
    } else {
      console.warn('HLS playback not supported in this browser');
    }
  }, [streamUrl]);

  return (
    <div className="live-stream">
      <div className="stream-header">
        <div>
          <h2>Live Stream</h2>
          <p>Live feed from At The Races</p>
        </div>
      </div>

      <div className="stream-container">
        <div className="stream-card-full">
          <div className="stream-preview-full">
            <video
              ref={videoRef}
              controls
              muted
              autoPlay
              playsInline
              className="stream-video"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveStream;

